import { render, staticRenderFns } from "./ViewAs.vue?vue&type=template&id=dd376408&scoped=true"
import script from "./ViewAs.vue?vue&type=script&lang=js"
export * from "./ViewAs.vue?vue&type=script&lang=js"
import style0 from "./ViewAs.vue?vue&type=style&index=0&id=dd376408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd376408",
  null
  
)

export default component.exports